<template>
  <v-app>
    <crm-lead-generator></crm-lead-generator>
  </v-app>
</template>

<script>
  import CrmLeadGenerator from '@/components/crm-lead-generator/crm-lead-generator.vue';

  export default {
    name: 'App',

    components: {
      CrmLeadGenerator,
    },

    mounted() {
      document.title = 'Export Market Finder';
    },
    data: () => ({}),
  };
</script>
